import React from 'react';
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { TextField, Typography, Button, Box, Card } from "@mui/material";
import * as Yup from "yup";
import "../../../Myaccount/Myaccount.css";
import Divider from "@mui/material/Divider";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { useTranslation } from "react-i18next";
import "../../../../Localization/i18n";



export default function ProjectEvaluationsection1(props) {
  const [value, setValue] = React.useState(dayjs('2014-08-18T21:11:54'));
  const { t } = useTranslation();
  const [EvaluatedBy, setEvaluatedBy] = React.useState(props?.data?.evaluatedBy);
  const handleChange = (event) => {
    setEvaluatedBy(event.target.value);
  };
  const validationSchema = Yup.object().shape({
    firstName: Yup.string()
      .required("FirstName is required !")
      .max(20, "First name must not exceed 20 characters"),
    lastName: Yup.string()
      .required("LastName is required !")
      .min(6, "LastName must be at least 6 characters")
      .max(20, "Last name must not exceed 20 characters"),
    title: Yup.string()
      .required("Title is required !")
      .min(6, "Title must be at least 6 characters")
      .max(20, "Title must not exceed 20 characters"),
    phoneNumber: Yup.string()
      .required("Phone number is required !")
      .matches(/^\(\d{3}\) \d{3}-\d{4}$/, "format like (000) 000-0000"),
    mobileNumber: Yup.string()
      .required("Mobile number is required !")
      .typeError("Mobile number is required !")
      .matches(/^\(\d{3}\) \d{3}-\d{4}$/, "format like (000) 000-0000"),
    email: Yup.string()
      .required("Email address is required !")
      .email("Email address is invalid"),
    additionalDescription: Yup.string()
      .required("Additiona iInformation is required !")
      .typeError("Additiona iInformation is required !")
      .min(10, "Additional information must be at least 10 characters"),
  });
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  return (
    <>
      <React.Fragment>

        <Card sx={{ paddingTop: "10px", paddingBottom: "12px" }}>
          <label className="personal-info-heading">
            <b>{t("ProjectEvalution.Section1")}</b>
          </label>
          <Divider sx={{ marginTop: 2, marginBottom: 2, backgroundColor: "#667085;", height: "1px" }} />
          {/* first section */}
          <div className="row mt-2">
            <div className="col-sm-5 col-md-5 col-xl-5 mt-4">
              <span className="input-label-right">
                {t("ProjectEvalution.Evaluatedby")}
                <small style={{ color: "red" }}>*</small>
              </span>
            </div>
            <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
              <FormControl sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
                width: "300px", backgroundColor: "#F2F4F7",

              }}>
                {props?.data?.evaluatedByDisplayName != null ?
                  <TextField
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={props?.data?.evaluatedByDisplayName}
                    //onChange={handleChange}
                    // disabled={props.data.canUserEdit}
                    disabled
                  />
                  :
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={EvaluatedBy}
                    onChange={handleChange}
                    // disabled={props.data.canUserEdit}
                    disabled
                  >
                    {props?.data?.clientUsers?.map((r) =>
                      <MenuItem value={r?.value}>{r?.key}</MenuItem>
                    )}
                  </Select>
                }
              </FormControl>
            </div>
            <div className="col-sm-2 col-md-2 col-xl-2 block"></div>
          </div>
          <Divider className="mt-3" />
          {/*2nd section */}
          <div className="row mt-2">
            <div className="col-sm-5 col-md-5 col-xl-5 mt-3">
              <span className="input-label-right">
                {t("ProjectEvalution.ReviewType")}{" "}

              </span>
            </div>
            <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
              {props?.data?.reviewType == 1 ?
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"

                  >
                    <FormControlLabel value={props?.data?.reviewType == 1} control={<Radio disabled checked={props?.data?.reviewType == 1 ? true : false} />} label="Project" sx={{ color: "#667085" }} />
                  </RadioGroup>
                </FormControl>
                :
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"

                  >
                    <FormControlLabel value={props?.data?.reviewType == 0} control={<Radio disabled checked={props?.data?.reviewType == 0 ? true : false} />} label="Annual" sx={{ color: "#667085" }} hidden={!props?.data?.isAnnualReviewRequired} />
                    <FormControlLabel value={props?.data?.reviewType == 2} control={<Radio disabled checked={props?.data?.reviewType == 2 ? true : false} />} label="Bi-Annual" sx={{ color: "#667085" }} hidden={!props?.data?.isBiAnnualReviewRequired} />
                  </RadioGroup>
                </FormControl>
              }
            </div>






            <div className="col-sm-2 col-md-2 col-xl-2 block"></div>
          </div>
          <Divider className="mt-3" />
          {/*3rd section */}
          <div className="row mt-2">
            <div className="col-sm-5 col-md-5 col-xl-5 mt-3">
              <span className="input-label-right">
                {t("ProjectEvalution.ReviewDate")}{" "}
                <small style={{ color: "red" }}>*</small>
              </span>
            </div>
            <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Stack spacing={3}>
                  <DesktopDatePicker
                    inputFormat="MM/DD/YYYY"
                    value={props?.data?.reviewDate}
                    onChange={handleChange}
                    renderInput={(params) => <TextField {...params}
                      sx={{
                        width: "300px", backgroundColor: "#F2F4F7", "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                      }} />}

                    disabled
                  />
                </Stack>
              </LocalizationProvider>

            </div>
            <div className="col-sm-2 col-md-2 col-xl-2 block"></div>
          </div>
          <Divider className="mt-3" />
          {/*4th section */}
          <div className="row mt-2" hidden={!props?.data?.projectLocation}>
            <div className="col-sm-5 col-md-5 col-xl-5 mt-3 ">
              <span className="input-label-right">

                {t("ProjectEvalution.ProjectLocation")}
              </span>
              <small style={{ color: "red" }}>*</small>
            </div>
            <div className="col-sm-4 col-md-4 col-xl-4 mt-1" >
              <TextField
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "300px"
                }}
                required
                value={props?.data?.projectLocation || ""}
                id="email"
                name="email"
                placeholder={t("ProjectEvalution.ProjectLocation")}
                size="small"
                className="form-control text-feild-custom"
                disabled
              />

            </div>
            <div className="col-sm-2 col-md-2 col-xl-2 block"></div>
          </div>
          <Divider className="mt-3" hidden={!props?.data?.projectLocation} />
          {/*5th section */}
          <div className="row mt-2" hidden={!props?.data?.contractWONumber}>
            <div className="col-sm-5 col-md-5 col-xl-5 mt-3">
              <span className="input-label-right">
                {t("ProjectEvalution.ContractororWO")}{" "}
                <small style={{ color: "red" }}>*</small>
              </span>
            </div>
            <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
              <TextField
                value={props?.data?.contractWONumber}
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "300px"
                }}
                disabled
                required
                type="text"
                id="phoneNumber"
                name="phoneNumber"
                placeholder={t("ProjectEvalution.ContractororWO")}
                size="small"
                className="form-control text-feild-custom"
                {...register("phoneNumber")}
              />

            </div>
            <div className="col-sm-2 col-md-2 col-xl-2 block"></div>
          </div>



        </Card>

      </React.Fragment>
    </>
  )
}
